document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ahs-product-card, .product-card, .pd").forEach((card) => {
    const variantJson = card.querySelector(".product-variants");
    if (!variantJson) return;

    // 1. Safe JSON Parsing
    let variants = [];
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (e) {
      console.error("Invalid variant JSON in product card:", card, e);
      return;
    }

    let currentVariant = null;
    let selectedOptions = {};

    /* ---------- Elements ---------- */
    const image = card.querySelector(".product-main-image, #pdStage");
    const sku = card.querySelector(".variant-sku");
    const price = card.querySelector(".variant-price");
    const addBtn = card.querySelector(".add-cart-btn");
    const qtySelect = card.querySelector(".qty-input"); // Targets the dropdown
    const variantInput = card.querySelector(".variant-id");

    const colorLabel = card.querySelector(".color-label, #colorLabel");
    const sizeLabel = card.querySelector(".size-label, #sizeLabel");

    const teamSlug = card.dataset.teamSlug || "";

    /* ---------- Default Selected Options ---------- */
    const activeSize = card.querySelector(".size-btn.active, .sizeway .is-on");
    if (activeSize) {
      selectedOptions.Size = activeSize.dataset.optionValue || activeSize.textContent.trim();
    }

    const activeColor = card.querySelector(".color-btn.active, .colorway .is-on");
    if (activeColor) {
      selectedOptions.Color =
        activeColor.dataset.optionValue ||
        activeColor.dataset.name ||
        activeColor.title;
    }

    /* ---------- SIZE LISTENERS ---------- */
    card.querySelectorAll(".size-btn, .sizeway button").forEach((btn) => {
      btn.addEventListener("click", () => {
        card.querySelectorAll(".size-btn, .sizeway button").forEach((b) => {
          b.classList.remove("active", "is-on");
          b.setAttribute("aria-pressed", "false");
        });

        btn.classList.add("active", "is-on");
        btn.setAttribute("aria-pressed", "true");

        selectedOptions.Size = btn.dataset.optionValue || btn.textContent.trim();

        if (sizeLabel) sizeLabel.textContent = selectedOptions.Size;
        updateVariant();
      });
    });

    /* ---------- COLOR LISTENERS ---------- */
    card.querySelectorAll(".color-btn, .colorway button").forEach((btn) => {
      btn.addEventListener("click", () => {
        card.querySelectorAll(".color-btn, .colorway button").forEach((b) => {
          b.classList.remove("active", "is-on");
          b.setAttribute("aria-pressed", "false");
        });

        btn.classList.add("active", "is-on");
        btn.setAttribute("aria-pressed", "true");

        selectedOptions.Color =
          btn.dataset.optionValue ||
          btn.dataset.name ||
          btn.title;

        if (colorLabel) colorLabel.textContent = selectedOptions.Color;
        updateVariant();
      });
    });

    /* ---------- UPDATE VARIANT ---------- */
    function updateVariant() {
      const matchedVariant = variants.find((v) => {
        let match = true;
        if (selectedOptions.Size) {
          match = match && v.options.includes(selectedOptions.Size);
        }
        if (selectedOptions.Color) {
          match = match && v.options.includes(selectedOptions.Color);
        }
        return match;
      });

      currentVariant = matchedVariant || variants[0];
      if (!currentVariant) return;

      if (sku) sku.textContent = currentVariant.sku || "";

      if (price) {
        price.textContent = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(currentVariant.price / 100);
      }

      if (image && currentVariant.image) {
        image.src = currentVariant.image;
      }

      if (variantInput) {
        variantInput.value = currentVariant.id;
      }

      if (addBtn) {
        addBtn.dataset.variantId = currentVariant.id;
        addBtn.disabled = !currentVariant.available;
        addBtn.textContent = currentVariant.available ? "Add to cart" : "Sold Out";
      }
    }

    // Initialize initial state
    updateVariant();

    /* ---------- AJAX ADD TO CART ---------- */
    if (addBtn) {
      addBtn.addEventListener("click", async () => {
        if (!currentVariant || !currentVariant.available || addBtn.classList.contains("loading")) {
          return;
        }

        addBtn.classList.add("loading");
        addBtn.disabled = true;
        addBtn.textContent = "Adding...";

        try {
          // 1. Update Global Cart Attributes if teamSlug exists
          if (teamSlug) {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                attributes: { team_slug: teamSlug }
              })
            });
          }

          // 2. Read selected quantity from dropdown
          const quantity = qtySelect ? Number(qtySelect.value) : 1;

          // 3. Add item to cart with Line Item Properties
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: currentVariant.id,
              quantity: quantity,
              properties: teamSlug ? { 
                "Team": teamSlug,
                "_team_slug": teamSlug 
              } : {}
            })
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || "Failed to add to cart");
          }

          // Dispatch event for themes with ajax cart drawers
          document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

          // Redirect to cart page
          window.location.href = "/cart";

        } catch (e) {
          console.error("Add to cart error:", e);
          alert(e.message || "Unable to add product.");
          addBtn.disabled = false;
          addBtn.classList.remove("loading");
          addBtn.textContent = currentVariant.available ? "Add to cart" : "Sold Out";
        }
      });
    }
  });
});